import React, { useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PendingFiles from './context';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import List from '~/containers/List';
import { showPerson, editPerson } from '~/config/routes';
import { AbilityContext } from '~/contexts/Can';
import moment from 'moment';

function PendingFilesList() {
  const { t } = useTranslation();
  const ability = useContext(AbilityContext);
  const listEl = useRef(null);

  const trAttr = (attr) => t(`pendingFiles.attributes.${attr}`);

  const actions = ['search'];

  if (ability.can('show', 'Files')) {
    actions.push('show');
  }

  return (
    <List
      listEl={listEl}
      routeToEdit={editPerson}
      routeToShow={showPerson}
      path={'/admin/pending/'}
      actions={actions}
      paperProps={{
        Icon: LocalHospitalIcon,
        iconColor: 'blue',
        title: t('pendingFiles.defPlural'),
      }}
      columns={[
        {
          title: trAttr('user_id'),
          field: 'id',
          type: 'numeric',
          precision: 0,
          includeThousandsSeparator: false,
        },
        { title: trAttr('name'), field: 'name', type: 'string' },
        { title: trAttr('created_at'), field: 'created_at', type: 'string' },
      ]}
      context={PendingFiles}
      recordMap={(record) => ({
        id: record.user_id,
        name: record.name,
        created_at: record.created_at
          ? moment(record.created_at).format('DD/MM/YYYY HH:mm')
          : null,
      })}
    />
  );
}

export default React.memo(PendingFilesList);
